<template>
  <div class="event-page">
    <div class="container" :class="{'mobile-view': isMobile, 'loaded': pageLoaded, 'eng-mode': isEng}">
      <RouterLink
        :to="{ name: 'index'}"
        title="logo"
        class="logo"
      />
      <!-- <div v-if="!isMobile" class="test">
        <a v-for="(n, index) in 13" :key="index" href="#" @click="curSection = n">
          {{ n }}
        </a>
        **{{ curSection }}
      </div> -->
      <a v-if="pageLoaded && langSelected === 'tw'" href="#" class="translate" @click="changLangs('en')">
        <span>EN</span>
      </a>
      <a v-else-if="pageLoaded" href="#" class="translate" @click="changLangs('tw')">
        <span>CN</span>
      </a>
      <div v-if="pageLoaded" class="social-media">
        <a href="https://www.facebook.com/muzikcom/" class="icon-fb" target="_blank" @click="gaClick('engagement', 'click', 'facebook')">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18">
            <path id="fb" fill="#FFF" d="M16.194.286c.525 0 .949.424.949.948V16.48a.948.948 0 0 1-.949.949H11.83v-6.641h2.221l.335-2.59H11.83V6.548c0-.748.201-1.25 1.284-1.25l1.361-.011v-2.31l-.332-.035a20.732 20.732 0 0 0-1.654-.066c-1.976 0-3.337 1.205-3.337 3.415V8.2H6.92v2.589h2.232v6.64H.949A.948.948 0 0 1 0 16.48V1.234C0 .71.424.286.949.286h15.245z" />
          </svg>
        </a>
        <a href="https://www.instagram.com/muzikmagazine/" class="icon-ig" target="_blank" @click="gaClick('engagement', 'click', 'instagram')">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="ig" d="M11.4286 8.85704C11.4286 10.4307 10.1451 11.7142 8.57146 11.7142C6.99779 11.7142 5.71431 10.4307 5.71431 8.85704C5.71431 7.28338 6.99779 5.9999 8.57146 5.9999C10.1451 5.9999 11.4286 7.28338 11.4286 8.85704ZM12.9688 8.85704C12.9688 6.424 11.0045 4.45972 8.57146 4.45972C6.13842 4.45972 4.17413 6.424 4.17413 8.85704C4.17413 11.2901 6.13842 13.2544 8.57146 13.2544C11.0045 13.2544 12.9688 11.2901 12.9688 8.85704ZM14.1741 4.28115C14.1741 3.71195 13.7165 3.25436 13.1473 3.25436C12.5782 3.25436 12.1206 3.71195 12.1206 4.28115C12.1206 4.85034 12.5782 5.30793 13.1473 5.30793C13.7165 5.30793 14.1741 4.85034 14.1741 4.28115ZM8.57146 1.82579C9.82146 1.82579 12.5 1.72534 13.6273 2.17177C14.0179 2.32802 14.3081 2.51775 14.6094 2.81909C14.9107 3.12043 15.1005 3.41061 15.2567 3.80123C15.7032 4.92847 15.6027 7.60704 15.6027 8.85704C15.6027 10.107 15.7032 12.7856 15.2567 13.9128C15.1005 14.3035 14.9107 14.5936 14.6094 14.895C14.3081 15.1963 14.0179 15.3861 13.6273 15.5423C12.5 15.9887 9.82146 15.8883 8.57146 15.8883C7.32145 15.8883 4.64288 15.9887 3.51565 15.5423C3.12503 15.3861 2.83485 15.1963 2.53351 14.895C2.23217 14.5936 2.04244 14.3035 1.88619 13.9128C1.43976 12.7856 1.5402 10.107 1.5402 8.85704C1.5402 7.60704 1.43976 4.92847 1.88619 3.80123C2.04244 3.41061 2.23217 3.12043 2.53351 2.81909C2.83485 2.51775 3.12503 2.32802 3.51565 2.17177C4.64288 1.72534 7.32145 1.82579 8.57146 1.82579ZM17.1429 8.85704C17.1429 7.674 17.154 6.50213 17.0871 5.31909C17.0201 3.94632 16.7076 2.72981 15.7032 1.72534C14.6987 0.720877 13.4822 0.408377 12.1094 0.341414C10.9264 0.274449 9.75449 0.28561 8.57146 0.28561C7.38842 0.28561 6.21654 0.274449 5.03351 0.341414C3.66074 0.408377 2.44422 0.720877 1.43976 1.72534C0.435294 2.72981 0.122794 3.94632 0.0558297 5.31909C-0.0111346 6.50213 2.61582e-05 7.674 2.61582e-05 8.85704C2.61582e-05 10.0401 -0.0111346 11.2119 0.0558297 12.395C0.122794 13.7678 0.435294 14.9843 1.43976 15.9887C2.44422 16.9932 3.66074 17.3057 5.03351 17.3727C6.21654 17.4396 7.38842 17.4285 8.57146 17.4285C9.75449 17.4285 10.9264 17.4396 12.1094 17.3727C13.4822 17.3057 14.6987 16.9932 15.7032 15.9887C16.7076 14.9843 17.0201 13.7678 17.0871 12.395C17.154 11.2119 17.1429 10.0401 17.1429 8.85704Z" fill="white" />
          </svg>
        </a>
        <a href="https://www.youtube.com/user/MUZIKmagazine" class="icon-yt" target="_blank" @click="gaClick('engagement', 'click', 'youtube')">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
            <path id="yt" fill="#FFF" fill-rule="nonzero" d="M10.652.827c3.842.02 6.346.2 6.346.2l.265.026c.41.043 1.023.15 1.6.68l.186.188c.14.164.6.775.75 1.94l.049.404c.161 1.473.152 2.833.152 2.833l-.003 1.89c-.01.572-.048 1.718-.198 2.865-.159 1.22-.661 1.84-.771 1.963l-.021.023c-.57.595-1.195.743-1.637.8l-.424.041c-.398.028-3.07.208-6.946.208l-1.303-.014c-4.169-.057-5.494-.187-5.494-.187-.418-.073-1.327-.058-2.065-.708l-.145-.14s-.614-.614-.792-1.986l-.049-.404C-.009 9.976 0 8.616 0 8.616l.003-1.89C.013 6.153.05 5.007.2 3.861c.178-1.384.792-1.987.792-1.987.617-.653 1.3-.775 1.744-.822l.54-.044a111.74 111.74 0 0 1 6.07-.182h1.305zM7.935 4.833v5.613l5.402-2.79-5.402-2.823z" />
            <linearGradient id="icon-gradient" x2="1" y2="1">
              <stop offset="0%" stop-color="#b963a1" />
              <stop offset="100%" stop-color="#483e97" />
            </linearGradient>
          </svg>
        </a>
        <a v-if="!isMobile" href="#" class="icon-share" @click="shareLink">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18">
            <defs>
              <path id="share" d="M13.5 11.76c.384 0 .744.099 1.08.297.336.198.603.465.801.801.198.336.297.696.297 1.08 0 .384-.099.747-.297 1.089a2.278 2.278 0 0 1-.801.819 2.045 2.045 0 0 1-1.08.306c-.384 0-.744-.102-1.08-.306a2.278 2.278 0 0 1-.801-.819 2.14 2.14 0 0 1-.297-1.089c0-.24.012-.402.036-.486l-5.31-3.096a2.212 2.212 0 0 1-1.548.594 2.17 2.17 0 0 1-1.116-.306 2.283 2.283 0 0 1-.828-.828A2.17 2.17 0 0 1 2.25 8.7c0-.396.102-.768.306-1.116.204-.348.48-.624.828-.828A2.17 2.17 0 0 1 4.5 6.45c.6 0 1.116.198 1.548.594l5.274-3.06-.046-.256a1.854 1.854 0 0 1-.026-.266c0-.396.102-.768.306-1.116.204-.348.48-.624.828-.828a2.17 2.17 0 0 1 1.116-.306c.396 0 .768.102 1.116.306.348.204.624.48.828.828.204.348.306.72.306 1.116 0 .396-.102.768-.306 1.116-.204.348-.48.624-.828.828a2.17 2.17 0 0 1-1.116.306c-.552 0-1.068-.21-1.548-.63L6.678 8.178l.046.236c.017.107.026.196.026.268 0 .12-.024.3-.072.54l5.346 3.096a2.199 2.199 0 0 1 1.476-.558z" />
            </defs>
            <g fill="#FFF" fill-rule="nonzero">
              <use xlink:href="#share" />
              <use xlink:href="#share" />
            </g>
          </svg>
        </a>
        <div class="copy-message" :class="{'active': isClickShareLink}">
          已複製連結
        </div>
        <input id="shareLinkInput" ref="shareLinkInput" v-model="canonicalURL" type="text">
      </div>
      <div v-if="!isMobile && (curSection > 3 && curSection < 10)" class="pagination">
        {{ curSection - 3 }}/6
      </div>
      <!-- Loading -->
      <div v-if="!pageLoaded" class="loading-content">
        <section v-background-image
                 class="section-loading flex-center"
                 :data-src="isMobile ? '/img/event/img-bg-m.png' : '/img/event/img-bg.png'"
                 :data-default-src="isMobile ? '/img/event/bg_64.png' : '/img/event/bg_180.png'"
        >
          <div class="content">
            <h2 class="sub-title">
              {{ $t('EVENT.PAGE_SUBTITLE') }}
            </h2>
            <h1 class="title" v-html="$t('EVENT.PAGE_TITLE2')" />
            <p class="percentage">
              {{ pageLoadingPercentage }} %
            </p>
          </div>
          <div class="tips">
            <i class="material-icons icon">
              headset
            </i>
            <p>{{ $t('EVENT.SOUND_ON') }}</p>
          </div>
        </section>
      </div>
      <!-- Main -->
      <div class="main-content" :class="{'show': pageLoaded}"
           :style="!isMobile ? {'transform': 'translate3d( 0, -' + curSection * 100 + '%, 0)'} : {}"
      >
        <section class="section-init flex-center">
          <div class="main-kv">
            <h2 class="sub-title">
              {{ $t('EVENT.PAGE_SUBTITLE') }}
            </h2>
            <h1 class="title" v-html="$t('EVENT.PAGE_TITLE')" />
            <div class="img-circles">
              <img v-for="n in 17" :key="n" :class="'circle'+ n" :src="'/img/event/circles/circle_' + n + '.png'">
            </div>
          </div>
          <a href="#" class="scroll-down" @click="setAllVideoUnmuted">
            <i class="material-icons icon">
              expand_more
            </i>
          </a>
        </section>
        <section class="section-origin flex-center" :class="{'active': curSection === 1}">
          <div class="content">
            <h3 class="section-title" v-html="$t('EVENT.INTRO_TITLE')" />
            <p class="desp" v-html="$t('EVENT.INTRO')" />
            <p v-if="!isEng" class="desp2" v-html="$t('EVENT.INTRO_2')" />
            <a v-if="!isEng" href="https://muzikair.page.link/sPJs" target="_blank"
               class="desp-expand"
               @click="gaClick('article', 'click', 'https://muzikair.page.link/sPJs')"
            >
              延伸閱讀：為什麼現代音樂長這樣？古典音樂「崩壞」小史
            </a>
            <ul v-if="clientWidth>=768" class="list">
              <li>
                <p class="year">
                  {{ $t('EVENT.PEOPLE_1_YEAR') }}
                </p>
                <img class="image" :src="'/img/event/timeline/w-1.png'">
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_1_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_1_WORK')" />
                </div>
              </li>
              <li>
                <p class="year">
                  {{ $t('EVENT.PEOPLE_2_YEAR') }}
                </p>
                <img class="image" :src="'/img/event/timeline/w-2.png'">
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_2_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_2_WORK')" />
                </div>
              </li>
              <li>
                <p class="year" v-html="$t('EVENT.PEOPLE_3_YEAR')" />
                <img class="image" :src="'/img/event/timeline/w-3.png'">
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_3_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_3_WORK')" />
                </div>
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_4_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_4_WORK')" />
                </div>
              </li>
            </ul>
            <ul v-else class="list">
              <img class="bg-timeline" :src="'/img/event/timeline/m-timeline2.png'">
              <li>
                <p class="year">
                  {{ $t('EVENT.PEOPLE_1_YEAR') }}
                </p>
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_1_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_1_WORK')" />
                </div>
              </li>
              <li>
                <p class="year">
                  {{ $t('EVENT.PEOPLE_2_YEAR') }}
                </p>
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_2_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_2_WORK')" />
                </div>
              </li>
              <li>
                <p class="year" v-html="$t('EVENT.PEOPLE_3_YEAR')" />
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_3_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_3_WORK')" />
                </div>
                <div class="info">
                  <p class="p-name" v-html="$t('EVENT.PEOPLE_4_NAME')" />
                  <p class="p-work" v-html="$t('EVENT.PEOPLE_4_WORK')" />
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section class="section-tonality-category flex-center" :class="{'active': curSection === 2}">
          <div class="content">
            <h3 class="section-title">
              {{ $t('EVENT.CATEGORY_TITLE') }}
            </h3>
            <div class="list">
              <div v-for="(n, index) in 5" :key="'category' + index" class="category grid-item" :class="'category0' + n">
                <h4 class="title">
                  {{ $t('EVENT.CATEGORY_' + n) }}
                </h4>
                <p class="desp">
                  {{ $t('EVENT.CATEGORY_DESP_' + n) }}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="section-prev flex-center" :class="{'active': curSection === 3}">
          <div class="content">
            <h3 class="section-title">
              {{ $t('EVENT.DESP_1') }}
            </h3>
          </div>
          <a href="#" class="scroll-down" @click="goDown">
            <i class="material-icons icon">
              expand_more
            </i>
          </a>
        </section>

        <!-- Video -->
        <section v-for="(vid, index) in videoData" :key="vid.src" class="section-video flex-center"
                 :class="{'playing': (curSection === (index+4) && isPlayingVideo === true) || curPlaying === index+1}"
        >
          <video :id="'video0' + (index + 1)" muted="muted" playsinline preload="none" :poster="'/img/event/img-v' + (index + 1) + '.jpg'">
            <source :src="'/video/' + vid.src + '.mp4'" type="video/mp4">
          </video>
          <div class="play-btn" @click="playVideo('video0'+ (index + 1), index+1)">
            <div class="triangle" />
          </div>
          <div class="content">
            <h3 class="section-title" :class="{'bg12': (index >= 3)}">
              {{ vid.title }}
            </h3>
            <p class="desp" :class="{'bg12': (index >= 3)}">
              {{ vid.desp }}
            </p>
          </div>
        </section>

        <!-- Review -->
        <section class="section-review flex-center" :class="{'active': curSection === 10}">
          <div class="content">
            <h3 class="section-title">
              {{ $t('EVENT.REVIEW') }}
            </h3>
            <ul class="list">
              <li v-for="(n, index) in 6" :key="index" @click="jumpToVideo(n) ">
                <p>{{ $t('EVENT.TYPE_' + (index)) }}</p>
                <div class="img-gif">
                  <img class="jpg" :src="'/img/event/jpg-' + (index + 1) + '.jpg'">
                  <img class="gif" :src="'/img/event/gif-' + (index + 1) + '.gif'">
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section class="section-articles flex-center" :class="{'active': curSection === 11}">
          <div class="content">
            <h3 class="section-title">
              {{ $t('EVENT.EXTENDED') }}
            </h3>
            <ul class="list">
              <li v-for="(article, index) in articleData" :key="index">
                <a :href="article.link" target="_blank" @click="gaClick('article', 'click', article.link)">
                  <div class="article-img" :style="{'background-image': 'url(' + article.src + ')', 'background-size': 'cover'}" />
                  <div class="article-info">
                    <h5 class="article-title">
                      {{ article.title }}
                    </h5>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </section>
        <section class="section-guide flex-center" :class="{'active': curSection === 12}">
          <div class="content">
            <h3 class="section-title">
              {{ $t('EVENT.GUIDE_TITLE') }}
            </h3>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/V4iHJsTywik" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </div>
        </section>
        <section class="section-final flex-center" :class="{'active': curSection === 13}">
          <div class="content">
            <div class="left">
              <h3 class="section-title">
                {{ $t('EVENT.FINAL_TITLE') }}
              </h3>
              <ul class="list">
                <li v-for="n in 6" :key="n">
                  {{ $t('EVENT.FINAL_LIST_' + n) }}
                </li>
              </ul>
            </div>
            <div class="right">
              <img src="/img/event/img-magazine.jpg">
              <p class="desp">
                {{ $t('EVENT.FINAL_DESP') }}<a target="_blank"
                                               href="https://shop.muzik.com.tw/products/2019%E5%B9%B410%E6%9C%88%E8%99%9F-no146%E7%8F%BE%E7%95%B6%E4%BB%A3%E9%9F%B3%E6%A8%82%E6%80%8E%E9%BA%BC%E8%81%BD" @click="gaClick('buynow', 'click', 'https://shop.muzik.com.tw/products/2019%E5%B9%B410%E6%9C%88%E8%99%9F-no146%E7%8F%BE%E7%95%B6%E4%BB%A3%E9%9F%B3%E6%A8%82%E6%80%8E%E9%BA%BC%E8%81%BD')"
                >
                  {{ $t('EVENT.FINAL_DESP2') }}
                </a>
              </p>
            </div>
          </div>
          <div v-if="pageLoaded && isMobile" class="social-media">
            <a href="https://www.facebook.com/muzikcom/" class="icon-fb" target="_blank" @click="gaClick('engagement', 'click', 'facebook')">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18">
                <path id="fb" fill="#FFF" d="M16.194.286c.525 0 .949.424.949.948V16.48a.948.948 0 0 1-.949.949H11.83v-6.641h2.221l.335-2.59H11.83V6.548c0-.748.201-1.25 1.284-1.25l1.361-.011v-2.31l-.332-.035a20.732 20.732 0 0 0-1.654-.066c-1.976 0-3.337 1.205-3.337 3.415V8.2H6.92v2.589h2.232v6.64H.949A.948.948 0 0 1 0 16.48V1.234C0 .71.424.286.949.286h15.245z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/muzikmagazine/" class="icon-ig" target="_blank" @click="gaClick('engagement', 'click', 'instagram')">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="ig" d="M11.4286 8.85704C11.4286 10.4307 10.1451 11.7142 8.57146 11.7142C6.99779 11.7142 5.71431 10.4307 5.71431 8.85704C5.71431 7.28338 6.99779 5.9999 8.57146 5.9999C10.1451 5.9999 11.4286 7.28338 11.4286 8.85704ZM12.9688 8.85704C12.9688 6.424 11.0045 4.45972 8.57146 4.45972C6.13842 4.45972 4.17413 6.424 4.17413 8.85704C4.17413 11.2901 6.13842 13.2544 8.57146 13.2544C11.0045 13.2544 12.9688 11.2901 12.9688 8.85704ZM14.1741 4.28115C14.1741 3.71195 13.7165 3.25436 13.1473 3.25436C12.5782 3.25436 12.1206 3.71195 12.1206 4.28115C12.1206 4.85034 12.5782 5.30793 13.1473 5.30793C13.7165 5.30793 14.1741 4.85034 14.1741 4.28115ZM8.57146 1.82579C9.82146 1.82579 12.5 1.72534 13.6273 2.17177C14.0179 2.32802 14.3081 2.51775 14.6094 2.81909C14.9107 3.12043 15.1005 3.41061 15.2567 3.80123C15.7032 4.92847 15.6027 7.60704 15.6027 8.85704C15.6027 10.107 15.7032 12.7856 15.2567 13.9128C15.1005 14.3035 14.9107 14.5936 14.6094 14.895C14.3081 15.1963 14.0179 15.3861 13.6273 15.5423C12.5 15.9887 9.82146 15.8883 8.57146 15.8883C7.32145 15.8883 4.64288 15.9887 3.51565 15.5423C3.12503 15.3861 2.83485 15.1963 2.53351 14.895C2.23217 14.5936 2.04244 14.3035 1.88619 13.9128C1.43976 12.7856 1.5402 10.107 1.5402 8.85704C1.5402 7.60704 1.43976 4.92847 1.88619 3.80123C2.04244 3.41061 2.23217 3.12043 2.53351 2.81909C2.83485 2.51775 3.12503 2.32802 3.51565 2.17177C4.64288 1.72534 7.32145 1.82579 8.57146 1.82579ZM17.1429 8.85704C17.1429 7.674 17.154 6.50213 17.0871 5.31909C17.0201 3.94632 16.7076 2.72981 15.7032 1.72534C14.6987 0.720877 13.4822 0.408377 12.1094 0.341414C10.9264 0.274449 9.75449 0.28561 8.57146 0.28561C7.38842 0.28561 6.21654 0.274449 5.03351 0.341414C3.66074 0.408377 2.44422 0.720877 1.43976 1.72534C0.435294 2.72981 0.122794 3.94632 0.0558297 5.31909C-0.0111346 6.50213 2.61582e-05 7.674 2.61582e-05 8.85704C2.61582e-05 10.0401 -0.0111346 11.2119 0.0558297 12.395C0.122794 13.7678 0.435294 14.9843 1.43976 15.9887C2.44422 16.9932 3.66074 17.3057 5.03351 17.3727C6.21654 17.4396 7.38842 17.4285 8.57146 17.4285C9.75449 17.4285 10.9264 17.4396 12.1094 17.3727C13.4822 17.3057 14.6987 16.9932 15.7032 15.9887C16.7076 14.9843 17.0201 13.7678 17.0871 12.395C17.154 11.2119 17.1429 10.0401 17.1429 8.85704Z" fill="white" />
              </svg>
            </a>
            <a href="https://www.youtube.com/user/MUZIKmagazine" class="icon-yt" target="_blank" @click="gaClick('engagement', 'click', 'youtube')">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
                <path id="yt" fill="#FFF" fill-rule="nonzero" d="M10.652.827c3.842.02 6.346.2 6.346.2l.265.026c.41.043 1.023.15 1.6.68l.186.188c.14.164.6.775.75 1.94l.049.404c.161 1.473.152 2.833.152 2.833l-.003 1.89c-.01.572-.048 1.718-.198 2.865-.159 1.22-.661 1.84-.771 1.963l-.021.023c-.57.595-1.195.743-1.637.8l-.424.041c-.398.028-3.07.208-6.946.208l-1.303-.014c-4.169-.057-5.494-.187-5.494-.187-.418-.073-1.327-.058-2.065-.708l-.145-.14s-.614-.614-.792-1.986l-.049-.404C-.009 9.976 0 8.616 0 8.616l.003-1.89C.013 6.153.05 5.007.2 3.861c.178-1.384.792-1.987.792-1.987.617-.653 1.3-.775 1.744-.822l.54-.044a111.74 111.74 0 0 1 6.07-.182h1.305zM7.935 4.833v5.613l5.402-2.79-5.402-2.823z" />
                <linearGradient id="icon-gradient" x2="1" y2="1">
                  <stop offset="0%" stop-color="#b963a1" />
                  <stop offset="100%" stop-color="#483e97" />
                </linearGradient>
              </svg>
            </a>
            <div class="copy-message" :class="{'active': isClickShareLink}">
              已複製連結
            </div>
            <input id="shareLinkInput" ref="shareLinkInput" v-model="canonicalURL" type="text">
          </div>
          <div class="footer">
            © 2019 MUZIK Creative Digital Ltd.
          </div>
        </section>
      </div>
      <!-- template content  -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContemporaryMusic2019',
  components: {},
  directives: {
    'background-image': {
      inserted(el, binding) {
        if (el.dataset.src) {
          const img = new Image()
          img.src = el.dataset.src
          img.onload = function () {
            el.style['background-image'] = 'url("' + img.src + '")'
          }
          img.onerror = (err) => {
            console.error('Image load error', err)
            if (el.dataset.defaultSrc && el.src !== el.dataset.defaultSrc) {
              el.style['background-image'] = 'url("' + el.dataset.defaultSrc + '")'
              setTimeout(() => {
                el.style.opacity = 1
              }, 60)
            }
          }
        }
      }
    }
  },
  props: {},
  data() {
    return {
      pageLoaded: false,
      langSelected: this.$i18n.locale === 'zh-TW' ? 'tw' : 'en',
      translateY: 0,
      curSection: 0,
      curPlaying: 0,
      debounceTimer: 0,
      touchYOffset: 0,
      isPlayingVideo: false,
      isAllVideoUnmuted: false,
      enforceLoad: false,
      videoLoaded: [false, false, false, false, false, false],
      isPageOverflow: false,
      isClickShareLink: false,
      pageLoadingTime: 0,
      pageLoadingPercentage: 0
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth
    },
    isMobile() {
      return this.clientWidth <= 1024
    },
    isEng() {
      return this.$i18n.locale !== 'zh-TW'
    },
    videoData() {
      const prefix = this.isMobile ? 'm' : 'm'
      return [{
        title: this.$t('EVENT.TRACK_TITLE'),
        desp: this.$t('EVENT.TRACK_INTRO'),
        src: prefix + '01',
        label: 'original'
      }, {
        title: this.$t('EVENT.TYPE_1'),
        desp: this.$t('EVENT.TYPE_DESP_1'),
        src: prefix + '02',
        label: 'twisted'
      }, {
        title: this.$t('EVENT.TYPE_2'),
        desp: this.$t('EVENT.TYPE_DESP_2'),
        src: prefix + '03',
        label: 'rhythm'
      }, {
        title: this.$t('EVENT.TYPE_3'),
        desp: this.$t('EVENT.TYPE_DESP_3'),
        src: prefix + '04',
        label: 'pitch'
      }, {
        title: this.$t('EVENT.TYPE_4'),
        desp: this.$t('EVENT.TYPE_DESP_4'),
        src: prefix + '05',
        label: 'music'
      }, {
        title: this.$t('EVENT.TYPE_5'),
        desp: this.$t('EVENT.TYPE_DESP_5'),
        src: prefix + '06',
        label: 'sound'
      }]
    },
    articleData() {
      return [{
        title: '沒有調性，如何聆聽非調性音樂',
        link: 'https://muzikair.page.link/9RwH',
        src: '/img/event/img-article01.jpg'
      }, {
        title: '沒有韻律，淺談現代音樂中的時間',
        link: 'https://muzikair.page.link/JRrh',
        src: '/img/event/img-article02.jpeg'
      }, {
        title: '沒有音高，我們最熟悉的陌生人——打擊樂',
        link: 'https://muzikair.page.link/umxm',
        src: '/img/event/img-article03.png'
      }, {
        title: '是噪音還是音樂，談聲音的解放與無限可能性',
        link: 'https://muzikair.page.link/C2Jp',
        src: '/img/event/img-article04.jpg'
      }, {
        title: '真正的寂靜？如果有人想睡覺那就讓他去睡',
        link: 'https://muzikair.page.link/Uuh2',
        src: '/img/event/img-article05.jpg'
      }, {
        title: '容易親近的當代「甜」音樂推薦作品',
        link: 'https://muzikair.page.link/wWAi',
        src: '/img/event/img-article06.jpg'
      }]
    },
    title() {
      const titlePostfix = `${this.$t('EVENT.PAGE_TITLE2')} | MUZIK READ`
      return titlePostfix
    },
    description() {
      return this.$t('EVENT.INTRO')
    },
    keywords() {
      let keywords = []
      keywords.push(this.$t('EVENT.PAGE_TITLE2'))
      keywords.push(this.$t('EVENT.PAGE_SUBTITLE'))
      keywords.push(this.$t('EVENT.INTRO_TITLE'))
      keywords.push(this.$t('EVENT.INTRO'))
      keywords.push(this.$t('EVENT.CATEGORY_TITLE'))
      for (let i = 1; i <= 5; i++) {
        keywords.push(this.$t('EVENT.CATEGORY_' + i))
        keywords.push(this.$t('EVENT.CATEGORY_DESP_' + i))
      }
      this.videoData.forEach(video => {
        keywords.push(video.title)
        keywords.push(video.desp)
      })
      return keywords.join(', ')
    },
    cover() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/event/eventsite.png`
    },
    canonicalURL() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/event/ContemporaryMusic2019`
    },
    structuredData() {
      return [
        {
          '@context': 'http://schema.org',
          '@type': 'Article',
          '@id': this.canonicalURL,
          'mainEntityOfPage': {
            '@type': 'WebPage',
            '@id': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}`
          },
          'headline': this.title,
          'name': this.title,
          'image': this.cover,
          'keywords': this.keywords,
          'url': this.canonicalURL,
          'publisher': {
            '@type': 'Organization',
            'name': 'MUZIK AIR',
            'logo': {
              '@type': 'ImageObject',
              'url': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/read.png`
            }
          },
          'description': this.description
        },
        {
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            '@type': 'ListItem',
            'position': 1,
            'item': {
              '@id': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/event/ContemporaryMusic2019`,
              'name': this.$t('EVENT.PAGE_TITLE2')
            }
          }]
        }
      ]
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.pageInit()
    window.addEventListener('resize', this.pageInit)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pageInit)
    this.destroyEventListener()
  },
  updated() {},
  methods: {
    calculatePageLoad() {
      let start = 0
      let width = 100 // width of a progress bar in percentage
      let perfData = window.performance.timing // The PerformanceTiming interface
      let estimatedTime = -(perfData.loadEventEnd - perfData.navigationStart) // Calculated Estimated Time of Page Load which returns negative value.
      this.pageLoadingTime = parseInt((estimatedTime / 1000) % 60) * 100 // Converting EstimatedTime from miliseconds to seconds
      this.animateValue('', start, width, this.pageLoadingTime)
    },
    animateValue(id, start, end, duration) {
      let range = end - start
      let current = start
      let increment = (end > start) ? 1 : -1
      let stepTime = Math.abs(Math.floor(duration / range))
      let timer = setInterval(() => {
        current += increment
        this.pageLoadingPercentage = current
        if (current === end) {
          clearInterval(timer)
        }
      }, stepTime)
    },
    pageInit() {
      this.curSection = 0
      this.isPageOverflow = false
      this.elementScrollTo('container')
      this.destroyEventListener()
      this.pauseAllVideo()
      let vids = document.getElementsByTagName('video')
      if (this.pageLoadingPercentage === 0) {
        this.calculatePageLoad()
      }
      // ENFORCE load all video
      if (!this.enforceLoad) {
        for (let i = 0; i < vids.length; i++) {
          vids[i].load()
        }
        this.enforceLoad = true
      }
      // Check if all video loaded
      for (let i = 0; i < vids.length; i++) {
        if (vids[i].readyState > 3) {
          this.videoLoaded[i] = true
        }
      }
      this.pageLoaded = this.videoLoaded.every(load => load === true) && (this.pageLoadingPercentage === 100)
      if (this.pageLoaded) {
        if (!this.isMobile) {
          this.isPageOverflow = true
          window.addEventListener('wheel', this.debounceWithWheel)
          window.addEventListener('touchstart', this.debounceWithTouchStart)
          window.addEventListener('touchend', this.debounceWithTouchEnd)
        } else {
          this.destroyEventListener()
        }
      } else {
        setTimeout(this.pageInit, 1000)
      }
    },
    destroyEventListener() {
      window.removeEventListener('wheel', this.debounceWithWheel)
      window.removeEventListener('touchstart', this.debounceWithTouchStart)
      window.removeEventListener('touchend', this.debounceWithTouchEnd)
    },
    changLangs(locale) {
      if (locale === 'en') {
        this.langSelected = 'en'
      } else {
        this.langSelected = 'tw'
      }
      this.$store.dispatch('GTAG_EVENT', {
        action: 'click',
        data: {
          'event_category': 'engagement',
          'event_label': 'change_lang ' + locale
        }
      })
      this.$router.push({ params: { locale: locale } })
    },
    // Video Control
    playVideo(vid, index, delay) {
      const currentVideo = document.getElementById(vid)
      // const dalayTime = 0 //delay || (this.isMobile ? 0 : 1000)
      this.pauseAllVideo()
      // dalay for css transition or scrolling time
      // setTimeout(() => {
      //   currentVideo.play()
      // }, dalayTime)
      currentVideo.currentTime = 0
      currentVideo.play()
      currentVideo.muted = false
      this.isPlayingVideo = true
      this.$store.dispatch('GTAG_EVENT', {
        action: 'play',
        data: {
          'event_category': 'video',
          'event_label': this.videoData[index - 1].label
        }
      })
      // for mobile us
      if (index && index !== '') {
        this.curPlaying = index
      }
      currentVideo.onended = e => {
        currentVideo.currentTime = 0
        this.isPlayingVideo = false
        this.curPlaying = 0
      }
    },
    pauseAllVideo() {
      let vids = document.getElementsByTagName('video')
      for (let i = 0; i < vids.length; i++) {
        vids[i].pause()
        this.curPlaying = 0
      }
      this.isPlayingVideo = false
    },
    setAllVideoUnmuted() {
      let vids = document.getElementsByTagName('video')
      for (let i = 0; i < vids.length; i++) {
        vids[i].muted = false
      }
      this.isAllVideoUnmuted = true
      if (this.isMobile) {
        let winHeight = document.body.clientHeight
        this.elementScrollTo('container', winHeight)
      } else {
        this.curSection = 1
      }
    },
    jumpToVideo(vIndex) {
      this.curSection = vIndex + 3
      if (this.isMobile) {
        let videoSection = document.getElementById('video0' + vIndex).offsetParent
        this.elementScrollTo('container', videoSection.offsetTop)
      }
      this.gaClick('review', 'click', this.videoData[vIndex - 1].label)
      // this.playVideo('video0' + Number(vIndex), '', 1200)
    },
    goDown() {
      if (this.isMobile) {
        let videoPos = document.getElementById('video01').offsetParent
        this.elementScrollTo('container', videoPos.offsetTop)
      } else {
        this.curSection = 4
      }
    },
    elementScrollTo(elementClassName, height = 0, behavior = '') {
      let container = document.getElementsByClassName(elementClassName)[0]
      container.scrollTo({
        top: height,
        behavior: 'smooth'
      })
    },
    shareLink() {
      this.$refs.shareLinkInput.select()
      this.$refs.shareLinkInput.setSelectionRange(0, this.canonicalURL.length)
      const successful = document.execCommand('copy')
      if (successful) {
        this.isClickShareLink = true
        setTimeout(() => {
          this.isClickShareLink = false
        }, 1000)
      }
      this.gaClick('engagement', 'click', 'copy')
    },
    gaClick(category, action, label) {
      this.$store.dispatch('GTAG_EVENT', {
        action: action,
        data: {
          'event_category': category,
          'event_label': label
        }
      })
    },
    // Wheel event
    onWheel(e) {
      const delta = Math.sign(e.deltaY)
      if (delta === 1) {
        if (this.curSection > 0 && this.curSection < 13) this.curSection++
      } else {
        if (this.curSection > 0) this.curSection--
      }
      if (this.curSection > 3 && this.curSection < 10) {
        this.pauseAllVideo()
        // this.playVideo('video0' + Number(this.curSection - 3))
      } else if (this.curSection === 3 || this.curSection === 10) {
        this.pauseAllVideo()
      }
    },
    // Touch event
    onTouchStart(e) {
      let touchobj = e.changedTouches[0]
      this.touchYOffset = touchobj.clientY
    },
    onTouchEnd(e) {
      let touchobj = e.changedTouches[0]
      if (this.touchYOffset - touchobj.clientY > 0) {
        if (this.curSection < 13) this.curSection++
      } else {
        if (this.curSection > 0) this.curSection--
      }
      this.touchYOffset = touchobj.clientY
    },
    debounceWithWheel(e) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.onWheel(e)
      }, 40)
    },
    debounceWithTouchStart(e) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.onTouchStart(e)
      }, 50)
    },
    debounceWithTouchEnd(e) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.onTouchEnd(e)
      }, 50)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

// basic
$bg-color: #231f20;
$txt-color: #a8a8a8;
$title-size: 36px;
$title-mg-bottom: 48px;
$desp-size: 16px;

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg12 {
  background-color: #121212;
}

@keyframes bounce-animation {
  0% {
    transform: translateY(0)
  }
  20% {
    transform: translateY(0)
  }
  40% {
    transform: translateY(-15px)
  }
  50% {
    transform: translateY(0)
  }
  60% {
    transform: translateY(-8px)
  }
  80% {
    transform: translateY(0)
  }
  100% {
    transform: translateY(0)
  }
}

@keyframes wave-animation{
  0%{background-position: 0 bottom};
  100%{background-position: 120px bottom};
}
@keyframes loading-animation{
  0%{background-size: 120px 0px};
  100%{background-size: 120px 120px};
}
@keyframes message-animation{
  0%{
    opacity: 0;
    transform: scale(0.1) rotate(30deg) translateY(50px) rotateX(90deg);
  }
  50%{
    transform: rotate(-10deg) rotateX(-2deg);
    opacity: 1;
  }
  70%{
    transform: rotate(3deg);
  }
  100%{
    transform: scale(1);
  }
}

// page style
.event-page {
  display: block;
  position: relative;
  color: #fff;
  background: $bg-color;
  // common
  .container {
    display: block;
    position: relative;
    width: 100%;
    max-width: 1440px;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;
    &.eng-mode{
      section{
        .main-kv{
          .title{
            font-size: 50px;
            line-height: 2.1;
            text-align: left;
            top: 42%;
            left: 24%;
          }
          .sub-title{
            font-size: 28px;
          }
        }
        .section-title{
          margin-bottom: 48px;
        }
        .section-desp{
          margin: 0;
        }
        &.section-loading{
          .title{
            max-width: 80%;
            margin: auto;
          }
        }
        &.section-origin{
          .section-title{
            margin-bottom: 16px;
          }
          .desp{
            max-width: 980px;
          }
          .list li + li + li .info + .info{
            bottom: 5.5%;
          }
        }
        &.section-tonality-category{
          .list{
            max-width: 1020px;
            .category{
              max-width: 340px;
              height: 260px;
              padding: 0 24px;
            }
          }
        }
        &.section-video{
          .content{
            max-width: 600px;
          }
          .section-title{
            margin-bottom: 0;
            text-align: left;
          }
        }
      }
      /deep/ b{
        font-style: italic;
      }
    }
  }
  .logo {
    display: inline-block;
    position: absolute;
    width: 96px;
    height: 32px;
    background: url('/img/event/img-logo.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    top: 30px;
    left: 24px;
    z-index: 1;
  }
  .translate{
    display: inline-block;
    position: absolute;
    width: 32px;
    height: 32px;
    top: 30px;
    right: 24px;
    text-align: center;
    text-decoration: none;
    color: #fff;
    z-index: 1;
    vertical-align: middle;
    background: #008be4;
    background: linear-gradient(to right, #86c28f, #417abb);
    background-size: 100% 100%;
    border-radius: 50%;
    span{
      display: inline-block;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;
      width: 30px;
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      background: $bg-color;
      background: $bg-color \9;
      border: none;
      border-radius: 40px;
      -webkit-appearance: none;
      transition: all 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
  .social-media {
    display: inline-block;
    position: absolute;
    left: 24px;
    bottom: 30px;
    z-index: 1;
    a {
      position: relative;
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 24px;
      vertical-align: top;
      svg {
        position: relative;
        width: 100%;
        height: 100%;
        #fb, #ig, #yt, #share{
          fill: #fff;
          transition: .2s;
        }
        &:hover {
          #fb, #ig, #yt, #share{
            fill: url(#icon-gradient) #b963a1;
          }
        }
      }
      &.icon-yt {
        width: 20px;
        height: 15px;
      }
      &:last-child {
        margin: 0;
      }
    }
    .copy-message{
      display: inline-block;
      width: 80px;
      height: 32px;
      position: absolute;
      top: -48px;
      left: 100px;
      font-size: 12px;
      color: $bg-color;
      background: #fff;
      padding: 10px;
      border-radius: 4px;
      transform-origin: center 60px;
      transform: scale(0);
      &.active{
        animation: message-animation 800ms ease-in-out forwards;
      }
      &:after {
        content: '';
        top: 100%;
        left: 50%;
        border: solid transparent;
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(0, 151, 167, 0);
        border-top-color: #fff;
        border-width: 6px;
        margin-left: -6px;
      }
    }
    #shareLinkInput{
      width: 10px;
      height: 0;
      opacity: 0;
      pointer-events: none;
    }
  }
  .pagination {
    display: inline-block;
    position: absolute;
    right: 64px;
    bottom: 62px;
    -webkit-text-stroke: 1px #ffffff;
    background-color: rgba(216, 216, 216, 0);
    font-size: 36px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 1.73px;
    user-select: none;
    text-align: right;
    color: rgba(216, 216, 216, 0);
    z-index: 1;
  }
  .test{
    position: absolute;
    top: 5px;
    left: 5px;
    color: #fff;
    z-index: 1;
    a{
      margin: 0 5px;
      color: #fff;
      text-decoration: none;
    }
  }
  // for video
  video {
    object-fit: cover;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  .play-btn {
    width: 415px;
    height: 415px;
    display: inline-block;
    position: relative;
    z-index: 1;
    cursor: pointer;
    &:before,
    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.1;
      border-radius: 50%;
    }
    &:after {
      width: 54%;
      height: 54%;
      opacity: 0.2;
      top: 23%;
      left: 23%;
    }
    .triangle {
      display: inline-block;
      position: absolute;
      top: 41%;
      left: 43%;
      width: 0px;
      height: 0px;
      border-top: 40px solid transparent;
      border-bottom: 40px solid transparent;
      border-left: 73.56px solid #fff;
    }
  }

  .main-content,
  .loading-content {
    display: block;
    position: relative;
    width: 100%;
    height: 100vh;
    transition: transform 550ms ease-in-out, -webkit-transform 550ms ease-in-out;
  }
  .main-content{
    opacity: 0;
    transition: opacity 1.5s, transform 1s;
    transform: translate3d(0, 0%, 0px);
    section{
      transition: .8s;
      background: $bg-color
    }
    &.show{
      opacity: 1;
      section{
        background: url('/img/event/img-bg.png');
        background-size: contain;
        .main-kv .img-circles img{
          &.circle1{
            left: 36%;
          }
          &.circle3{
            left: 16.5%;
          }
          &.circle4{
            left: 25%;
          }
          &.circle5{
            left: 17.5%;
          }
          &.circle7{
            left: 20.8%;
          }
          &.circle12{
            left: 15.4%;
          }
          &.circle13{
            left: 21.6%;
          }
          &.circle15{
            left: 33.6%;
          }
          &.circle17{
            left: 35%;
          }
        }
      }
    }
  }
}

section {
  display: block;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url('/img/event/img-bg.png');
  background-size: contain;
  user-select: none;
  .main-kv {
    position: relative;
    .title {
      font-size: 76px;
      font-weight: 900;
      line-height: 1.5;
      text-align: right;
      position: absolute;
      top: 40%;
      left: 32%;
      margin: 0;
      z-index: 2;
    }
    .sub-title {
      font-size: 48px;
      font-weight: 300;
      position: absolute;
      top: 26%;
      left: 23.5%;
      margin: 0;
      z-index: 2;
    }
    .img-circles{
      position: relative;
      width: 1000px; // 1120px;
      height: 590px; // 652px;
      // max-width: 1120px;
      z-index: 1;
      overflow: visible;
      img{
        position: absolute;
        top: 0;
        left: 25%;
        width: 72%;
        transition: 2.2s;
        &.circle1{ // 38
          left: 32%;
        }
        &.circle2{
          top: 5.8%;
          left: 40%;
        }
        &.circle3{
          top: 10.5%;
          left: 22.5%;
          transition: left 1.2s linear .4s;
        }
        &.circle4{
          top: 13.5%;
          left: 17%;
          transition: left 2s linear .4s;
        }
        &.circle5{
          top: 19.8%;
          left: 13.5%;
          transition: left 1.8s linear .4s;
        }
        &.circle6{
          top: 38.7%;
          left: -0.2%;
        }
        &.circle7{
          top: 40.3%;
          left: 22.8%;
          transition: left 1.6s linear .4s;
        }
        &.circle8{
          top: 51.3%;
          left: 14.5%;
        }
        &.circle9{
          top: 51.5%;
          left: 20.8%;
        }
        &.circle10{
          top: 59.3%;
          left: 28.6%;
        }
        &.circle11{
          top: 60.5%;
          left: 20.4%;
        }
        &.circle12{
          top: 63.2%;
          left: 13.5%;
          transition: left 1.6s linear .4s;
        }
        &.circle13{
          top: 78.7%;
          left: 26.6%;
        }
        &.circle14{
          top: 85.4%;
          left: 16%;
        }
        &.circle15{
          top: 88%;
          left: 36.6%;
          transition: left 1.8s linear .4s;
        }
        &.circle16{
          top: 91.5%;
          left: 47%;
        }
        &.circle17{
          top: 92.8%;
          left: 30%;
          transition: left 2.2s linear .4s;
        }
      }
    }
    .img-kv{
      display: none;
    }
  }
  .content {
    display: inline-block;
    width: 100%;
  }
  .section-title {
    font-size: 36px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    margin: 0 0 90px;
  }
  .section-desp {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .scroll-down{
    position: absolute;
    z-index: 3;
    bottom: 20px;
    text-decoration: none;
    text-align: center;
    animation: bounce-animation 1.8s infinite;
    p{
      font-size: 16px;
      text-decoration: none;
      margin: 0 0 4px;
      color: #fff;
    }
    i{
      font-size: 48px;
      color: #fff;
    }
  }
  //
  &.section-loading{
    text-align: center;
    background: $bg-color;
    transition: background-image .15s;
    background: url('/img/event/bg_180.png');
    background-size: contain;
    .content{
      margin-bottom: 80px;
    }
    .sub-title{
      font-size: 54px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #525252;
      margin: 0 0 8px;
    }
    .title{
      font-size: 84px;
      font-weight: 900;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #525252;
      margin: auto;

      background: rgb(136,193,128);
      background: linear-gradient(90deg, rgba(136,193,128,1) 0%, rgba(241,236,105,1) 50%, rgba(136,193,128,1) 100%);
      background-clip: text;
      color: rgba(0,0,0,0);
      text-shadow: 0px 0px rgba(255,255,255,0.06);
      animation: wave-animation .8s infinite linear, loading-animation 8s infinite linear alternate;
      background-size: 120px 100px;
      background-repeat:repeat-x;
      opacity:1;
    }
    .percentage{
      font-size: 36px;
      font-weight: 900;
      padding: 0;
      margin: 50px 0 0;
      background: rgb(136,193,128);
      background: linear-gradient(90deg, rgba(136,193,128,1) 0%, rgba(241,236,105,1) 50%, rgba(136,193,128,1) 100%);
      background-clip: text;
      color: rgba(0,0,0,0);
      text-shadow: 0px 0px rgba(255,255,255,0.06);
      animation: wave-animation .8s infinite linear;
      background-size: 100px 50px;
    }
    .tips{
      text-align: center;
      position: absolute;
      bottom: 64px;
      left: 0;
      right: 0;
      p{
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        color: #919090;
        margin: 8px 0 0;
      }
      i{
        font-size: 72px;
        color: #919090;
      }
    }
  }
  &.section-init {
    color: #000;

  }
  &.section-origin {
    text-align: center;
    .content {
      max-width: 1020px;
    }
    .section-title {
      display: block;
      margin: 0 0 1em;
    }
    .desp,
    .desp2{
      max-width: 1020px;
      margin: 0 auto 16px;
      font-size: 16px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.94;
    }
    .desp-expand{
      display: inline-block;
      color: #fff;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.4;
      letter-spacing: normal;
      text-align: center;
      padding: 0;
      margin: 20px;
      &:after{
        content: '';
        display: block;
        position: relative;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right, #88c180 0%, #f1ec69 100%);
        bottom: -3px;
      }
      &:hover{
        color: #88c180;
      }
    }
    .list{
      display: flex;
      position: relative;
      list-style: none;
      margin: 36px auto 0;
      padding: 0;
      width: 100%;
      max-width: 112vh;
      left: -32px;
      li{
        display: inline-block;
        position: relative;
        padding: 10px;
        float: left;
        padding: 0;
        text-align: center;
        .image{
          position: relative;
          height: 30vh;
          width: auto;
          max-height: 250px;
        }
        .year{
          position: relative;
          width: 100%;
          height: 36px;
          font-size: 24px;
          font-weight: 500;
          line-height: 36px;
          letter-spacing: normal;
          margin: 0;
          padding: 0;
          top: 4px;
          left: 0;
          right: 0;
          margin: auto;
        }
        .info{
          position: relative;
          margin-top: 18px;
          .p-name,
          .p-work{
            font-size: 16px;
            font-weight: 500;
            line-height: normal;
            margin: auto;
            padding: 0;
          }
        }
        &+li{
          .image,
          .year,
          .info{
            left: -5%;
          }
        }
        &+li+li{
          .info{
            left: -25%;
            &+.info{
              position: absolute;
              width: 100%;
              left: 15%;
              bottom: 0;
            }
          }
          &:after{
            content: '';
            display: block;
            clear: both;
          }
        }
      }
    }
  }
  &.section-tonality-category {
    text-align: center;
    .list {
      display: block;
      max-width: 840px;
      margin: 0 auto;
      text-align: center;
      .category {
        display: inline-block;
        max-width: 280px;
        height: 240px;
        vertical-align: top;
        padding: 0 36px;
      }
      .title {
        display: inline-block;
        font-size: 26px;
        margin: 0 0 16px;
        font-weight: bold;
        line-height: normal;
        &:after{
          content: '';
          display: block;
          position: relative;
          width: 100%;
          height: 1px;
          background-image: linear-gradient(to right, #88c180 0%, #f1ec69 100%);
          bottom: -3px;
          opacity: 1;
          transition: .2s;
        }
      }
      .desp {
        display: block;
        font-size: $desp-size;
        font-weight: 500;
        line-height: 1.94;
        letter-spacing: normal;
        margin: 0;
      }
      &:after {
        content: '';
        display: block;
        clear: both;
      }
    }
  }
  &.section-video {
    .content {
      position: absolute;
      top: 230px; // 22%;
      left: 64px;
      max-width: 530px;
      .section-title {
        display: inline-block;
        font-size: 48px;
        font-weight: bold;
        font-style: normal;
        line-height: 1.5;
        margin: 0;
      }
      .desp {
        max-width: 90%;
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.94;
        margin: 5px 0;
      }
      iframe{
        width: 100%;
        height: 100%;
      }
    }
  }
  &.section-review{
    .content{
      max-width: 1000px;
      margin: 0 auto;
    }
    .section-title{
      color: #ffffff;
      margin-bottom: 32px;
      margin-left: 10px;
    }
    .list{
      display: block;
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        display: inline-block;
        vertical-align: top;
        width: 33.33%;
        padding: 0 42px;
        margin-bottom: 48px;
        p{
          font-size: 16px;
          font-weight: bold;
        }
        .img-gif{
          position: relative;
          height: 200px;
          overflow: hidden;
          img{
            position: absolute;
            height: 100%;
            width: auto;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }
          .jpg{
            display: none;
          }
        }
      }
      &:before{
        content: '';
        display: block;
        clear: both;
      }
    }
  }
  &.section-articles{
    .content{
      max-width: 1000px;
      margin: 0 auto;
    }
    .section-title{
      color: #ffffff;
      margin-bottom: 32px;
      margin-left: 10px;
    }
    .list{
      list-style: none;
      margin: 0;
      padding: 0;
      margin: 0 -10px;
      max-width: 1000px;
      margin: 0 auto;
      li{
        display: inline-block;
        position: relative;
        vertical-align: top;
        width: 33.33%;
        height: 250px;
        padding: 0 10px;
        margin: 0 0 36px;
        a{
          text-decoration: none;
        }
        .article-img{
          width: 100%;
          height: 178px;
          margin: 0 0 4px;
          overflow: hidden;
          img{
            height: 100%;
            width: auto;
          }
        }
        .article-info{
          .article-title{
            font-size: 18px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: normal;
            color: #a8a8a8;
            margin: 0 0 8px;
            @include ellipsis-with-lines(2);
          }
          .article-content{
            font-size: 12px;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #919090;
            margin: 0;
            @include ellipsis-with-lines(2);
          }
        }
        &:after{
          content: "";
          display: inline-block;
          position: absolute;
          bottom: 0;
          left: 10px;
          width: 0%;
          height: 3px;
          background-image: linear-gradient(to left, #483e97, #b963a1);
          transition: .4s;
        }
        &:hover{
          .article-info{
            .article-title{
              color: #fff;
            }
          }
          &:after{
            width: calc(100% - 20px);
          }
        }
      }
    }
  }
  &.section-guide{
    text-align: center;
    .section-title{
      margin-bottom: 64px;
    }
    iframe{
      max-width: 100%;
    }
  }
  &.section-final{
    .content{
      display: flex;
      flex-direction: row;
      width: 100%;
      max-width: 780px;
      margin: 0 auto;
    }
    .left,
    .right{
      width: 60%;
      text-align: left;
    }
    .section-title{
      text-align: left;
      margin-bottom: 55px;
    }
    .left{
      .list{
        list-style: none;
        margin: 0;
        padding: 0;
        li{
          font-size: 20px; // 16px;
          font-weight: bold;
          line-height: 2.4; // 2;
          color: $txt-color;
        }
      }
    }
    .right{
      width: 45%;
      text-align: center;
      img{
        width: 100%;
        max-width: 350px;
        height: auto;
      }
      p{
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        text-align: center;
        color: #fff;
        margin-top: 8px;
        a{
          display: inline-block;
          position: relative;
          color: #fff;
          font-size: 20px;
          line-height: normal;
          text-decoration: none;
          &:after{
            content: '';
            display: block;
            position: relative;
            width: 100%;
            height: 1px;
            background-image: linear-gradient(to right, #88c180 0%, #f1ec69 100%);
            bottom: -3px;
          }
        }
      }
    }
    .footer{
      display: block;
      position: absolute;
      bottom: 36px;
      left: 0;
      right: 0;
      margin: auto;
      font-size: 16px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
    }
  }
  &.playing {
    .play-btn {
      display: none;
    }
  }
}

@media only screen and (min-width: 1025px) {
  section {
    background: red;
    &.section-origin {
      .content{
        .section-title{
          opacity: 0;
          transition: .65s all linear .6s;
        }
        .desp,
        .desp2,
        .desp-expand{
          opacity: 0;
          transition: .75s opacity linear 1s, .2s color linear 0s;;
        }
        .list{
          li{
            opacity: 0;
            transition: .8s all linear 1.2s;
            &+li{
              transition-delay: 1.6s;
              &+li{
                transition-delay: 2s;
              }
            }
          }
        }
      }
      &.active{
        .content{
          .section-title,
          .desp,
          .desp2,
          .desp-expand,
          .list li{
            opacity: 1;
          }
        }
      }
    }
    &.section-tonality-category,
    &.section-review,
    &.section-articles,
    &.section-guide{
      .content{
        .section-title{
          opacity: 0;
          transition: .45s all linear .6s;
        }
        .list,
        iframe{
          opacity: 0;
          transition: .8s all linear .8s;
        }
      }
      &.active{
        .content{
          .section-title,
          .list,
          iframe{
            opacity: 1;
          }
        }
      }
    }
    &.section-tonality-category{
      .list{
        .category{
          transition: .4s;
          transform: translateY(20px);
          &:hover{
            transform: translateY(0px);
            .title{
              &:after{
                opacity: 0;
              }
            }
            .desp{
              opacity: 1;
            }
          }
        }
        .desp{
          opacity: 0;
          transition: .4s;
        }
      }
    }
    &.section-review{
      .list{
        li{
          position: relative;
          cursor: pointer;
          .img-jpg{
            display: block;
          }
          .img-gif{
            .jpg,
            .gif{
              display: block;
              transition: .1s;
            }
            .jpg{
              opacity: 1;
            }
            .gif{
              opacity: 0;
            }
            &:hover{
              .jpg{
                opacity: 0;
              }
              .gif{
                opacity: 1;
              }
            }
          }
        }
      }
    }
    &.section-final{
      .right{
        transition: .45s all ease-in .8s;
        transform: translateX(200px);
        opacity: 0;
      }
      &.active{
        .right{
          transform: translateX(0px);
          opacity: 1;
        }
      }
    }
  }
}

@media only screen and (min-width: 1600px) and (min-height: 1000px) {
  .event-page{
    .logo{
      width: 113px;
      height: 30px;
    }
    .translate{
      width: 45px;
      height: 45px;
      span{
        width: 41px;
        height: 41px;
        line-height: 41px;
        font-size: 18px;
      }
    }
  }
  section{
    .main-kv{
      .img-circles{
        width: 1120px;
        height: 652px;
      }
      .title{
        font-size: 84px;
      }
      .sub-title{
        font-size: 52px;
      }
    }
    &.section-tonality-category{
      .list{
        max-width: 970px;
        .category{
          max-width: 320px;
          padding: 0 48px;
          height: 260px;
        }
      }
    }
    &.section-review{
      .section-title{
        margin-bottom: 48px;
      }
      .list{
        margin: 0 -32px;
        li{
          .img-gif{
            height: 240px;
          }
        }
      }
    }
    &.section-articles{
      .section-title{
        margin-bottom: 48px;
      }
      .list{
        li{
          margin-bottom: 64px;
          .article-info{
            .article-title{
              line-height: 1.6;
            }
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (max-width: 1439.98px) {
  $title-size: 32px;
  $desp-size: 14px;
  $title-mg-bottom: 32px;

  section {
    .main-kv{
      .title{
        font-size: 5.5vw;
      }
      .sub-title{
        font-size: 3vw;
      }
      .img-circles{
        width: 70vw;
        height: 41.2vw;
      }
    }
    .section-title{
      font-size: $title-size;
      margin-bottom: $title-mg-bottom;
    }
    .scroll-down{
      bottom: 6px;
      p{
        font-size: 14px;
      }
      i{
        font-size: 40px;
      }
    }
    &.section-loading{
      .title{
        font-size: 5.5vw;
      }
      .sub-title{
        font-size: 3.5vw;
      }
      .percentage{
        margin-top: 24px;
      }
      .tips{
        i{
          font-size: 4.5vw;
        }
        p{
          font-size: 1.5vw;
          margin: 2px 0 0
        }
      }
    }
    &.section-origin{
      .desp,
      .desp2,
      .desp-expand{
        max-width: 880px;
        padding: 0 1.5em;
        font-size: $desp-size;
      }
      .desp,
      .desp2{
        margin: 0 auto 12px;
      }
      .desp-expand{
        margin-bottom: 8px;
      }
      .image{
        height: 40vh;
      }
    }
    &.section-tonality-category{
      .section-title{
        margin: 0 0 52px;
      }
      .section-desp{
        font-size: 18px;
        color: #a8a8a8;
        margin-top: 35px;
      }
      .list{
        .category{
          height: 150px;
          padding: 0 20px;
        }
        .title{
          font-size: 26px;
          margin: 0 0 8px;
        }
        .desp{
          font-size: $desp-size;
        }
      }
    }
    &.section-review{
      .content{
        max-width: 880px;
      }
      .list{
        margin: 0 -30px;
        padding: 0;
        li{
          margin-bottom: 24px;
          p{
            font-size: $desp-size;
            margin: 0;
          }
          .img-gif{
            height: 140px;
          }
        }
      }
    }
    &.section-articles{
      .content{
        max-width: 880px;
      }
      .list{
        li{
          margin: 0 0 24px;
          .article-img{
            height: 160px;
            margin: 0 0 6px;
          }
          .article-info{
            .article-title{
              transition: .4s;
            }
          }
        }
      }
    }
    &.section-final{
      .content{
        max-width: 680px;
      }
      .section-title{
        margin-bottom: 36px;
      }
      .left{
        .list{
          li{
            font-size: 18px;
            line-height: 2;
          }
        }
      }
      .right{
        img{
          max-width: 250px;
        }
        p{
          font-size: 16px;
          a{
            font-size: 16px;
          }
        }
      }
    }
  }
  .event-page{
    .container.eng-mode{
      section{
        .main-kv{
          .title{
            font-size: 3.5vw;
          }
          .sub-title{
            font-size: 2.2vw;
          }
        }
        .section-title{
          margin-bottom: 32px;
        }
        &.section-tonality-category{
          .list{
            .category{
              padding: 0 20px;
              height: 200px;
            }
          }
        }
        &.section-video{
          .content{
            max-width: 580px;
          }
          .section-title{
            font-size: 3.2vw;
          }
        }
        &.section-final .footer{
          font-size: 14px;
        }
      }
    }
  }
}
@media only screen and (max-height: 767.98px) {
  section {
    .scroll-down{
      bottom: 16px;
    }
  }
}
@media only screen and (max-width: 1024px) {
  .container{
    &.mobile-view{
     height: 100vh;
     overflow: hidden;
     &.loaded{
       height: auto;
       overflow-y: scroll;
       -webkit-overflow-scrolling: touch;
     }
    }
  }
  section{
    &.section-loading{
      background: url('/img/event/bg_64.png');
      background-size: cover;
    }
    &.section-origin{
      .list{
        left: 2%;
        li .image{
          height: 26vh;
        }
      }
    }
    &.section-tonality-category .list .title{
      margin-bottom: 16px;
    }
    &.section-final{
      padding-bottom: 60px;
      .social-media{
        display: block;
        position: absolute;
        bottom: 64px;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        a.icon-yt{
          margin: 0;
        }
      }
    }
  }
  .event-page .main-content.show section{
    background: url(/img/event/img-bg-m.png);
    background-size: cover;
  }
}

@media only screen and (device-width: 1024px) and (device-height: 1366px) and (orientation:portrait),
only screen and (device-width: 768px) and (device-height: 1024px) and (orientation:portrait)  {
  $title-size: 36px;
  $desp-size: 16px;
  // $title-mg-bottom: 32px;
  .event-page{
    .container{
      &.eng-mode{
        section{
          .main-kv{
            .sub-title{
              font-size: 2.5vw;
            }
            .title{
              font-size: 4.5vw;
            }
          }
          .section-title{
            font-size: 34px;
          }
          &.section-loading{
            .title{
              max-width: 90%;
              background-size: 120px 200px;
            }
          }
          &.section-origin{
            .desp{
              font-size: 16px;
            }
          }
          &.section-video{
            .section-title{
              font-size: 4vw;
            }
          }
        }
      }
    }
    .logo{
      top: 30px;
      left: 24px;
    }
    .translate{
      top: 24px;
      right: 24px;
    }
    .social-media{
      left: 24px;
      bottom: 24px;
    }
    .pagination{
      right: 24px;
      bottom: 24px;
    }
  }
  section{
    height: auto;
    min-height: 100vh;
    padding: 0 24px;
    .main-kv{
      .img-circles{
        width: 90vw;
        height: 53vw;
      }
      .title{
        font-size: 6.4vw;
      }
      .sub-title{
        font-size: 3.5vw;
      }
    }
    .section-title{
      font-size: $title-size;
      margin-bottom: $title-mg-bottom;
    }
    .scroll-down{
      bottom: 12%;
    }
    &.section-loading{
      .sub-title{
        font-size: 48px;
      }
      .title{
        font-size: 72px;
      }
      .tips{
        bottom: 12%;
        i{
          font-size: 5.5vw;
        }
        p{
          font-size: 2.5vw;
        }
      }
    }
    &.section-origin{
      .list{
        left: 0;
        li .image{
          height: 23vw;
        }
      }
    }
    &.section-tonality-category{
      .section-desp{
        font-size: 20px;
      }
      .list{
        .category{
          max-width: 320px;
          height: 180px;
          padding: 0 18px;
        }
        .title{
          font-size: 20px;
          margin: 0 0 8px;
        }
        .desp{
          font-size: 14px;
        }
      }
    }
    &.section-prev{
      .section-title{
        max-width: 450px;
        line-height: 1.5;
        margin: auto;
      }
    }
    &.section-video{
      .content{
        top: 22vh;
        left: 28px;
        .section-title{
          font-size: 36px;
        }
        .desp{
          margin: 8px 0;
        }
      }
    }
    &.section-review,
    &.section-articles{
      .content{
        max-width: 100%;
      }
      .section-title{
        margin: 48px 0 64px 0;
      }
    }
    &.section-review{
      .list{
        padding: 0 36px;
        li{
          width: 50%;
          margin-bottom: 100px;
          p{
            font-size: $desp-size;
          }
          .img-gif{
            height: 260px;
          }
        }
      }
    }
    &.section-articles{
      .list{
        li{
          width: 50%;
          padding: 0 32px;
          margin-bottom: 40px;
          height: 260px;
          .article-img{
            position: relative;
            padding-top: 56.25%;
            img{
              width: 100%;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
            }
          }
          .article-info{
            .article-title{
              font-size: 18px;
              line-height: 1.5;
              margin: 0 0 18px;
            }
          }
        }
      }
    }
    &.section-final{
      display: block;
      min-height: auto;
      padding: 200px 24px 300px;
      .content{
        max-width: 100%;
      }
      .left,
      .right{
        width: 50%;
      }
      .left{
        .list{
          padding-left: 40px;
          li{
            font-size: 20px;
            line-height: 2.4;
          }
        }
      }
      .right{
        img{
          max-width: 80%;
          margin-bottom: 20px;
        }
        p{
          max-width: 70%;
          margin: 0 auto;
        }
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  $page-padding: 16px;
  .event-page{
    .logo{
      width: 80px;
      height: 21px;
      top: 16px;
      left: 16px;
    }
    .translate{
      top: 12px;
      right: 16px;
    }
    .play-btn{
      width: 200px;
      height: 200px;
      .triangle{
        top: 38%;
        border-top: 23px solid transparent;
        border-bottom: 23px solid transparent;
        border-left: 40.975px solid #fff;
      }
    }

    .container{
      &.eng-mode{
        section{
          .main-kv{
            .sub-title{
              font-size: 3.4vw;
            }
            .title{
              font-size: 5vw;
            }
          }
          .section-title{
            font-size: 22px;
          }
          &.section-loading{
            .sub-title{
              font-size: 5vw;
            }
            .title{
              max-width: 100%;
              font-size: 8vw;
              padding: 0;
            }
            .percentage{
              font-size: 7.6vw;
            }
          }
          &.section-origin{
            padding-top: 80px;
            .section-title{
              margin-bottom: 20px;
            }
            .desp{
              font-size: 14px;
            }
            .list li + li + li{
              left: 11%;
            }
          }
          &.section-tonality-category{
            padding-top: 80px;
            .section-title{
              margin-bottom: 48px;
            }
            .list{
              .category{
                height: auto;
                max-width: 100%;
                margin-bottom: 60px;
              }
            }
          }
          &.section-video{
            .section-title{
              font-size: 5.4vw;
            }
          }
        }
      }
    }
  }
  section{
    height: auto;
    min-height: 100vh;
    padding: 16px;
    .main-kv{
      .img-circles{
        width: 105vw;
        height: 61vw;
      }
      .title{
        font-size: 7.8vw;
      }
      .sub-title{
        font-size: 4.8vw;
      }
    }
    .section-title{
      font-size: 20px;
    }
    .scroll-down{
      bottom: 10%;
    }
    &.section-loading{
      .sub-title{
        font-size: 36px;
      }
      .title{
        font-size: 48px;
        padding: 0 1em;
      }
      .tips{
        bottom: 120px;
        p{
          font-size: 16px;
        }
        i{
          font-size: 40px;
        }
      }
    }
    &.section-origin{
      padding: 80px 0 0;
      .section-title{
        padding: 0 $page-padding;
      }
      .desp,
      .desp2,
      .desp-expand{
        font-size: 12px;
        margin: 0 $page-padding 12px;
      }
      .desp,
      .desp2{
        padding: 0 .5em;
      }
      .desp-expand{
        margin: 0 auto 24px;
      }
      .list{
        display: block;
        max-width: 100%;
        margin: 0;
        left: 0;
        img{
          width: 100%;
          height: auto;
        }
        li{
          position: absolute;
          top: 12%;
          left: 15vw;
          text-align: right;
          .year{
            font-size: 24px;
            font-weight: 500;
            line-height: normal;
            letter-spacing: normal;
            color: #9b9b9b;
            margin: 0;
            padding: 0;
            max-width: 120px;
          }
          .info{
            margin: 0;
            .p-name{
              font-size: 14px;
              font-weight: 500;
              line-height: 1.5;
              letter-spacing: normal;
              margin: 0;
              padding: 0;
            }
            .p-work{
              font-size: 12px;
              font-weight: 500;
              line-height: 1.75;
              letter-spacing: normal;
              color: #9b9b9b;
              margin: 0;
              padding: 0;
            }
          }
          &+li{
            left: 57vw;
            top: 38%;
            text-align: left;
            &+li{
              top: 66%;
              left: 16vw;
              text-align: right;
              .year{
                left: 0;
              }
              .info{
                left: 0;
                margin-top: 8px;
                &+.info{
                  position: relative;
                  left: 0;
                  margin-top: 8px;
                }
              }
            }
          }
        }
      }
    }
    &.section-tonality-category{
      padding-top: 80px;
      .section-desp{
        font-size: 16px;
        line-height: 1.6;
        padding-bottom: 3em;
      }
      .list{
        .category{
          max-width: 100%;
          height: auto;
          margin-bottom: 100px;
          padding: 0 46px;
        }
        .title{
          font-size: 18px;
        }
        .desp{
          font-size: 12px;
        }
      }
    }
    &.section-prev{
      .section-title{
        max-width: 250px;
        line-height: 1.5;
        margin: auto;
      }
    }
    &.section-video{
      .content{
        top: initial;
        bottom: 18vh;
        left: initial;
        padding: 0 16px;
        .section-title{
          font-size: 24px;
        }
        .desp{
          font-size: 14px;
          max-width: 100%;
        }
      }
    }
    &.section-review,
    &.section-articles {
      .section-title{
        margin: 36px 0;
      }
    }
    &.section-review{
      .section-title{
        font-size: 20px;
        margin: 80px auto 48px;
      }
      .list{
        padding: 0 24px;
        text-align: center;
        li{
          width: 100%;
          margin-bottom: 64px;
          padding: 0;
          p{
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 24px;
          }
          .img-gif{
            max-width: 80%;
            height: 200px;
            overflow: hidden;
            margin: 0 auto;
            img{
              height: 100%;
              width: auto;
            }
          }
        }
      }
    }
    &.section-articles{
      .list{
        li{
          width: 100%;
          height: auto;
          margin-bottom: 36px;
          padding: 0;
          .article-img{
            position: relative;
            padding-top: 56.25%;
            margin-bottom: 4px;
            img{
              width: 100%;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
            }
          }
          .article-info{
            .article-title{
              margin-bottom: 8px;
            }
          }
        }
      }
    }
    &.section-final{
      padding: 64px 16px 120px;
      .content{
        display: block;
      }
      .section-title{
        margin-bottom: 24px;
        text-align: center;
      }
      .left,
      .right{
        width: 100%;
      }
      .left{
        .list{
          padding: 0;
          margin-bottom: 36px;
          li{
            font-size: 16px;
            line-height: 2.5;
          }
        }
      }
      .right{
        img{
          max-width: 100%;
        }
        a{
          font-size: 20px;
          max-width: 100%;
        }
      }
      .footer{
        font-size: 12px;
      }
    }
  }
}
@media only screen and (max-width: 320px) {
  .event-page .container.eng-mode{
    section.section-loading{
      .title{
        font-size: 9vw;
      }
      .tips{
        bottom: 60px;
      }
    }
    section.section-origin{
      .list li{
        top: 10%;
        .year{
          font-size: 20px;
        }
        .info{
          margin-top: 3px;
        }
        &+li{
          top: 35%;
          left: 59%;
          &+li{
            top: 65%;
            left: 5%;
          }
        }
      }
    }
  }
  section{
    &.section-loading{
      .title{
        font-size: 40px;
      }
      .sub-title{
        font-size: 28px;
      }
      .tips{
        bottom: 100px;
        i{
          font-size: 38px;
        }
        p{
          font-size: 14px;
        }
      }
    }
    &.section-origin .list li{
      left: 9%;
      &+li{
        &+li{
          .year{
            left: 0;
          }
          left: 11%;
        }
      }
    }
    &.section-tonality-category{
      padding-top: 80px;
      .list .category{
        margin-bottom: 60px;
      }
    }
    &.section-review{
      .section-title{
        margin: 40px auto 48px;
      }
    }
    .section-title{
      font-size: 18px;
    }
  }
}
</style>
